import { CustomAlert } from './CustomAlert.main';

export { CustomAlert };
